import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import { Box, Button, Card, FormControl, Grid, MenuItem, Select, Stack, TableContainer, Tooltip, Typography } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import { useState } from 'react';
import EditVendorIcon from '../../icons/EditPropertyIcon.svg';
import RemoveVendorIcon from '../../icons/RemovePropertyIcon.svg';
import ReinstateVendorIcon from '../../icons/re-instate.svg';
import { getFetchingVendorsData, selectVendors, selectVendorsCurrentPage, selectVendorsState } from './sagas/vendorsSlice';
import { useDispatch, useSelector } from 'react-redux';
import TableHeader from '../shared/TableHeader';
import SpinnerWithNoConfirmation from '../../shared/Modal/spinnerWithNoConfirmation';
import BadRequestIcon from '../../icons/Badrequesterror.svg';
import Error500 from '../../icons/505Error.svg';
import { Role, VendorSearchDTOSearchStatusEnum, VendorV2Dto } from '@inosio/payments-sdk';
import UpdateVendorStatusModal from './components/UpdateVendorStatusModal';
import ResidentPortalIcon from '../../icons/ResidentPortal.svg';
import RegisteredIcon from '../../icons/RegisteredIcon.svg';
import NotRegisteredIcon from '../../icons/NotRegisteredIcon.svg';
import UserRegistrationModalManager, { UserRegistrationProfileDetails } from '../../shared/userRegistration/UserRegistrationModalManager';
import VendorModal from './components/VendorModal';
import { selectAuthState } from '../../shared/sagas/auth/authSlice';
import LogAsProfileUserModal from '../../shared/logas/LogAsProfileUsersModal';

export default function Vendors() {
  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = React.useState(0);
  const [recordStartIndex, setRecordStartIndex] = useState(0);
  const [rangeSize, setRangeSize] = useState(100);
  const [searchField, setSearchField] = React.useState('');
  const [searchValue, setSearchValue] = React.useState('');
  const [isSearchValueEmpty, setIsSearchValueEmpty] = React.useState(false);
  const columnsSelectRef = React.createRef<HTMLSelectElement>();
  const [columnFilterSearchField, setColumnFilterSearchField] = React.useState('');
  const [searchChipOpen, setSearchChipOpen] = React.useState(false);
  const searchValueInputRef = React.createRef<HTMLInputElement>();
  const [searchBluePillValue, setSearchPillValue] = React.useState('');
  const [openUserRegistrationModalManager, setOpenUserRegistrationModalManager] = React.useState(false);
  const [openLogAsProfileUsersModal, setOpenLogAsProfileUsersModal] = useState(false);
  const VendorsData = useSelector(selectVendors);
  const { isFetchingVendors, isFetchingVendorsFailed, errorMessage } = useSelector(selectVendorsState);
  const { isSendingInvitationSuccess } = useSelector(selectAuthState);
  let VendorsDataBook = useSelector(selectVendorsCurrentPage);
  const setSearchPageIndex = (pageNumber: number) => {
    if (!VendorsDataBook[pageNumber]) {
      const newIndex = pageNumber * rangeSize;
      setRecordStartIndex(newIndex);
    }
  };
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPageNumber: number) => {
    setSearchPageIndex(newPageNumber);
    setCurrentPage(newPageNumber);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentPage(0);
    setRecordStartIndex(0);
    setRangeSize(parseInt(event.target.value));
  };
  const searchValueChangeHandler = (e: any) => {
    setSearchValue(e.target.value ? e.target.value.trim() : '');
  };
  const searchFieldChangeHandler = (e: any) => {
    setSearchField(e.target.value);
  };
  const handleChooseColumnSearchField = (event: any) => {
    event.preventDefault();
    if (columnsSelectRef?.current) {
      setColumnFilterSearchField(columnsSelectRef?.current?.value);
    }
  };
  const useStyles = makeStyles({
    gridContainer: {
      background: '#FFFFFF',
      borderRadius: '24px',
    },
  });
  const optionValues = [
    {
      key: 'Name',
      value: 'Description',
    },
    {
      key: 'ContactName',
      value: 'Name',
    },
  ];
  React.useEffect(() => {
    if (searchValue.length === 0) {
      setIsSearchValueEmpty(true);
    } else {
      setIsSearchValueEmpty(false);
    }
  }, [searchValue]);

  const [vendorStatus, setVendorStatus] = React.useState(VendorSearchDTOSearchStatusEnum.Active);
  React.useEffect(() => {
    searchVendors();
  }, [vendorStatus]);

  //if a new user invited fetch again
  React.useEffect(() => {
    if (isSendingInvitationSuccess) {
      searchVendors();
    }
  }, [dispatch, isSendingInvitationSuccess]);

  React.useEffect(() => {
    dispatch(
      getFetchingVendorsData({
        RangeSize: rangeSize,
        StartIndex: recordStartIndex,
      }),
    );
  }, [dispatch, rangeSize, recordStartIndex]);

  const resetTableRows = () => {
    setSearchChipOpen(false);
    setSearchValue('');
    setSearchField('');
    setSearchPillValue('');
    dispatch(
      getFetchingVendorsData({
        RangeSize: rangeSize,
        StartIndex: 0,
        SearchStatus: vendorStatus,
      }),
    );
  };

  const searchVendors = (event?: any) => {
    setCurrentPage(0);
    setSearchChipOpen(true);
    event && event.preventDefault();
    if (searchValueInputRef?.current && searchValueInputRef?.current?.value?.length !== 0) {
      setSearchPillValue(searchValueInputRef?.current?.value);
    }
    if (searchValueInputRef?.current?.value?.length !== 0) {
      dispatch(
        getFetchingVendorsData({
          RangeSize: rangeSize,
          StartIndex: 0,
          SearchField: searchField || undefined,
          SearchValue: searchValue || undefined,
          SearchStatus: vendorStatus,
        }),
      );
    } else {
      dispatch(
        getFetchingVendorsData({
          RangeSize: rangeSize,
          StartIndex: 0,
          SearchStatus: vendorStatus,
        }),
      );
    }
  };
  const classes = useStyles();

  const [selectedVendor, setSelectedVendor] = React.useState<VendorV2Dto>();
  const [isUpdateStatusModalOpen, setIsUpdateStatusModalOpen] = React.useState(false);
  const [isVendorModalOpen, setIsVendorModalOpen] = React.useState(false);

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 'calc( 100vh - 144px )', pb: '64px' }} className={classes.gridContainer} style={{ position: 'relative' }}>
        <React.Fragment>
          <Box sx={{ display: 'flex', p: 1, pb: 2, justifyContent: 'space-between', '& .MuiTextField-root': { m: 1, width: '25ch' } }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <TableHeader
                searchValueChangeHandler={searchValueChangeHandler}
                searchValue={searchValue}
                isSearchValueEmpty={isSearchValueEmpty}
                searchFieldChangeHandler={searchFieldChangeHandler}
                searchField={searchField}
                optionValues={optionValues}
                handleSearch={searchVendors}
                columnsSelectRef={columnsSelectRef}
                handleChooseColumnSearchField={handleChooseColumnSearchField}
                resetTableRows={resetTableRows}
                setSearchChipOpen={setSearchChipOpen}
                searchChipOpen={searchChipOpen}
                resetSearchFilter={setSearchField}
                resetSearchValue={setSearchValue}
                columnFilterSearchField={columnFilterSearchField}
                searchBluePillValue={searchBluePillValue}
                searchValueInputRef={searchValueInputRef}
                rangeSize={rangeSize}
                recordStartIndex={recordStartIndex}
                hideCalendarIcon={true}
                hideDateRangeSearchPillChip={true}
                hideCalendarModal={true}
              />

              <FormControl sx={{ pt: 0.5, pb: 2 }}>
                <Select
                  onChange={(e) => setVendorStatus(e.target.value as VendorSearchDTOSearchStatusEnum)}
                  value={vendorStatus}
                  inputProps={{ 'aria-label': 'Without label' }}
                  style={{ borderRadius: '24px', height: '42px' }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: '24px',
                      },
                    },
                  }}
                >
                  <MenuItem value={VendorSearchDTOSearchStatusEnum.Active}>Status: Active</MenuItem>
                  <MenuItem value={VendorSearchDTOSearchStatusEnum.Inactive}>Status: Inactive</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box>
              <Button
                variant="contained"
                style={{
                  width: '160px',
                  height: '46px',
                  borderRadius: '24px',
                  textTransform: 'capitalize',
                  color: 'white',
                  backgroundColor: '#39A2DB',
                  borderColor: '#39A2DB',
                }}
                onClick={() => {
                  setSelectedVendor(undefined);
                  setIsVendorModalOpen(true);
                }}
                id="addNewVendorBtn"
              >
                Add New Vendor
              </Button>
            </Box>
          </Box>
          {isFetchingVendorsFailed && String(errorMessage.statusCode)[0] === '4' ? (
            <Grid container direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
              <Grid item display="flex" flexDirection="column" alignItems="center">
                <Grid item display="flex" justifyContent="center" pb={3} mt={3}>
                  <img src={BadRequestIcon} alt="400" />
                </Grid>
                <Grid item justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '40px',
                      lineHeight: '23px',
                      color: '#2E82AF',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    {errorMessage.statusCode}
                  </Typography>
                </Grid>
                <Grid mt={2} item justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '20px',
                      lineHeight: '23px',
                      color: '#9E9E9E',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    Page not found.
                  </Typography>
                </Grid>
                <Grid item justifyContent="center" mt={2} xs={8}>
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '23px',
                      color: '#9E9E9E',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    {errorMessage.message.length === 0 ? '' : errorMessage.message}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ) : isFetchingVendorsFailed && String(errorMessage.statusCode)[0] === '5' ? (
            <Grid container direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
              <Grid item display="flex" flexDirection="column" alignItems="center">
                <Grid item display="flex" justifyContent="center" sx={{ marginLeft: '5%' }}>
                  <img src={Error500} alt="500" style={{ height: '35vh' }} />
                </Grid>
                <Grid item justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '40px',
                      lineHeight: '23px',
                      color: '#2E82AF',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    {errorMessage.statusCode}
                  </Typography>
                </Grid>
                <Grid mt={2} item justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '20px',
                      lineHeight: '23px',
                      color: '#9E9E9E',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    Page not found.
                  </Typography>
                </Grid>
                <Grid item justifyContent="center" mt={2} xs={8}>
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '23px',
                      color: '#9E9E9E',
                      textAlign: 'center',
                      marginTop: '10px',
                    }}
                  >
                    {errorMessage.message.length === 0 ? '' : errorMessage.message}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ) : isFetchingVendors ? (
            <Stack justifyContent="center" alignItems="center" style={{ height: '1100px' }}>
              <SpinnerWithNoConfirmation />
            </Stack>
          ) : (
            <TableContainer style={{ flex: 1 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell id="subTitle">Description</TableCell>
                    <TableCell id="subTitle">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        Vendor ID
                      </Stack>
                    </TableCell>
                    <TableCell id="subTitle">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        Name
                      </Stack>
                    </TableCell>
                    <TableCell id="subTitle">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        Registration
                      </Stack>
                    </TableCell>
                    <TableCell id="subTitle" sx={{ textAlign: 'center' }}>
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        Vendor Portal
                      </Stack>
                    </TableCell>
                    <TableCell id="subTitle">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        Edit
                      </Stack>
                    </TableCell>
                    <TableCell id="subTitle">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        {vendorStatus === VendorSearchDTOSearchStatusEnum.Active ? 'Remove' : 'Reinstate'}
                      </Stack>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ left: '28px' }}>
                  {VendorsDataBook?.[currentPage] &&
                    VendorsDataBook?.[currentPage].Rows?.map((eachRow: VendorV2Dto) => {
                      const isAtLeastOneRegisteredUser = !!eachRow.UserProfiles?.length;
                      return (
                        <TableRow key={eachRow.Uuid}>
                          <TableCell id="content">{`${eachRow.Name}`}</TableCell>
                          <TableCell id="content">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              {`${eachRow.ExternalRefId2 ?? ''}`}
                            </Stack>
                          </TableCell>
                          <TableCell id="content">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              {`${eachRow.ContactName}`}
                            </Stack>
                          </TableCell>
                          <TableCell id="content">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              <img
                                src={isAtLeastOneRegisteredUser ? RegisteredIcon : NotRegisteredIcon}
                                alt="vendor registration"
                                style={{ cursor: 'pointer' }}
                                className={isAtLeastOneRegisteredUser ? 'registered' : 'not-registered'}
                                onClick={() => {
                                  setSelectedVendor(eachRow);
                                  setOpenUserRegistrationModalManager(true);
                                }}
                              />
                            </Stack>
                          </TableCell>
                          <TableCell id="content">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              <Tooltip title="Login to vendor portal." placement="right">
                                {/* this will log pm into vendor portal */}
                                <img
                                  id="new-tab"
                                  src={ResidentPortalIcon}
                                  alt="vendor portal icon"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setSelectedVendor(eachRow);
                                    if (eachRow.UserProfiles?.length === 1) {
                                      const userToImpersonate = eachRow.UserProfiles?.[0]?.UserUuid;
                                      window.open(`/login?logAsEntityUuid=${eachRow.Uuid}&logAsUserUuid=${userToImpersonate}`, '_blank');
                                    } else if (!eachRow.UserProfiles?.length) {
                                      window.open(`/login?logAsEntityUuid=${eachRow.Uuid}`, '_blank');
                                    } else {
                                      setOpenLogAsProfileUsersModal(true);
                                    }
                                  }}
                                  className="logas-res-btn"
                                />
                              </Tooltip>
                            </Stack>
                          </TableCell>
                          <TableCell id="content">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              <img
                                onClick={() => {
                                  setIsVendorModalOpen(true);
                                  setSelectedVendor(eachRow);
                                }}
                                src={EditVendorIcon}
                                alt="Edit Vendor"
                                style={{ cursor: 'pointer' }}
                              />
                            </Stack>
                          </TableCell>
                          <TableCell id="content">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              <img
                                onClick={() => {
                                  setSelectedVendor(eachRow);
                                  setIsUpdateStatusModalOpen(true);
                                }}
                                src={vendorStatus === VendorSearchDTOSearchStatusEnum.Active ? RemoveVendorIcon : ReinstateVendorIcon}
                                alt="Remove Vendor"
                                style={{ cursor: 'pointer' }}
                              />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
          <TablePagination
            component="div"
            rowsPerPageOptions={[50, 100, 200]}
            count={VendorsData?.TotalCount}
            page={currentPage}
            onPageChange={handleChangePage}
            rowsPerPage={rangeSize}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ position: 'absolute', bottom: 10, right: 10 }}
          />
          {isVendorModalOpen && (
            <VendorModal
              open={isVendorModalOpen}
              selectedItem={selectedVendor}
              searchDataCallback={searchVendors}
              closeCallback={() => {
                setIsVendorModalOpen(false);
                setSelectedVendor(undefined);
              }}
            />
          )}
          {isUpdateStatusModalOpen && (
            <UpdateVendorStatusModal
              open={isUpdateStatusModalOpen}
              data={selectedVendor}
              searchDataCallback={searchVendors}
              closeCallback={() => {
                setIsUpdateStatusModalOpen(false);
                setSelectedVendor(undefined);
              }}
              vendorStatus={vendorStatus}
            />
          )}

          <UserRegistrationModalManager
            open={openUserRegistrationModalManager}
            profileUsers={selectedVendor?.UserProfiles || []}
            profileInvitedUsers={selectedVendor?.InvitedProfiles || []}
            onClose={() => {
              setSelectedVendor(undefined);
              setOpenUserRegistrationModalManager(false);
            }}
            profileDetails={
              {
                profileUuid: selectedVendor?.Uuid,
                profileRole: Role.Resident,
                profileIntegrationEmail: selectedVendor?.Email,
                profileIntegrationFirstName: selectedVendor?.ContactName,
                profileIntegrationLastName: selectedVendor?.Name,
                profileIntegrationMiddleName: '',
              } as UserRegistrationProfileDetails
            }
          />
          <LogAsProfileUserModal
            open={openLogAsProfileUsersModal}
            onClose={() => {
              setOpenLogAsProfileUsersModal(false);
              setSelectedVendor(undefined);
            }}
            profileUsers={selectedVendor?.UserProfiles || []}
            profileUuid={selectedVendor?.Uuid || ''}
          />
        </React.Fragment>
      </Card>
    </Grid>
  );
}
